<template>
  <div class="task-manager-1 px-md-4 pt-md-4 pb-md-2">
    <!-- create Tasks -->
    <div class="mx-3 mx-md-0">
      <div class="grid-main">
        <div>
          <h4 class="py-3 py-md-0 mx-3 mx-md-0">Listes de tâches</h4>
        </div>
        <div class="grid-iner">
          <div class="ml-md-3 mr-md-3 form-group search-icon">
            <span class="search-icon-item">
              <i class="fa fa-search" aria-hidden="true"></i>
            </span>
            <input
              class="form-control pl-5"
              :placeholder="$t('task.search')"
              v-model="search"
              type="text"
            />
          </div>

          <div class="ml-md-3 form-group form-field-style-5">
            <button class="create-new-btn" @click="showModal(false)">
              {{
                personalRoute ? $t("task.createPersonal") : $t("task.createNew")
              }}
            </button>
          </div>
          <div
            v-if="!personalRoute"
            class="ml-md-3 form-group form-field-style-5"
          >
            <button class="create-new-btn" @click="showModal(true)">
              {{ $t("task.bulkTask") }}
            </button>
          </div>
        </div>
      </div>

      <!-- <div class="mx-3 mx-md-0 d-flex flex-column flex-md-row  justify-content-end mr-0 mr-lg-3">

	      </div> -->
      <!-- <div class="ml-md-4 d-flex flex-lg-column justify-content-between">
          <div class="mr-md-2 form-group form-field-style-1">
            <label class="checkbox-main"> {{$t('task.todayCheckBox')}}
              <input type="radio" value="day" v-model="type">
              <span class="checkmark"></span>
            </label>
          </div>
          <div class="form-group form-field-style-2">
            <label class="checkbox-main">{{$t('task.weekCheckBox')}}
              <input type="radio" value="week" v-model="type">
              <span class="checkmark"></span>
            </label>
          </div>
        </div> -->
    </div>
  </div>
</template>
<script>
import TaskHelper from "../../helper/TaskHelper";

export default {
  data() {
    return {
      type: "",
      search: "",
    };
  },

  mounted() {
    const currentUser = this.$store.state.user.informations;
    this.$root.$on("createTask", () => {
      this.refreshType();
    });
  },

  computed: {
    personalRoute() {
      return this.$route.path == "/personalTasks";
    },
  },

  methods: {
    showModal(flag) {
      this.$emit("setBulkFlag", flag);
      this.$root.$emit("createSimpleTask"); // to fetch lastest comments
      this.$modal.show("create-simple-task");
    },

    selectApi() {
      this.$emit("whichTasks", this.type);
    },

    searchByName() {
      this.$emit("name", this.search);
    },

    refreshType() {
      this.type = "";
    },
  },

  watch: {
    type: {
      handler: "selectApi",
    },
    search: {
      handler: "searchByName",
    },
  },
};
</script>
<style lang="scss">
.grid-main {
  display: grid;
  grid-template-columns: 30% 70%;
  @media (min-width: 320px) and (max-width: 600px) {
    grid-template-columns: 100%;
  }
}
.grid-iner {
  display: grid;
  grid-template-columns: 51% 110px 110px;
  grid-gap: 35px;
  @media (min-width: 320px) and (max-width: 600px) {
    grid-template-columns: 50% 50%;
    grid-gap: 5px;
  }
}
.checkbox-main {
  display: block;
  position: relative;
  padding-left: 25px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  .checkmark {
    position: absolute;
    top: 5px;
    left: 0;
    height: 15px;
    width: 15px;
    background-color: transparent;
    border: 2px solid #4f78e2;
    border-radius: 2px;
    &:after {
      content: "";
      position: absolute;
      display: none;
    }
    &:after {
      left: 4px;
      top: 1;
      width: 4px;
      height: 8px;
      border: solid #fff;
      border-width: 0 1px 1px 0;
      -webkit-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }
  &:hover {
    input ~ .checkmark {
      background-color: transparent;
    }
  }
  input:checked ~ .checkmark {
    background-color: #4f78e2;
    &:after {
      display: block;
    }
  }
}
.form-field-style-5 {
  width: 131px;
  .create-new-btn {
    background-color: #4f78e2;
    width: 100%;
    height: 35px;
    border: none;
    border-radius: 3px;
    color: #fff;
    font-family: "SF-Pro-Text";
    font-weight: 500;
    &:focus {
      outline: none;
    }
  }
}
.search-icon {
  position: relative;
  .search-icon-item {
    position: absolute;
    height: 36px;
    width: 35px;
    z-index: 1;
    i {
      position: relative;
      top: 8px;
      left: 4px;
      font-size: 14px;
      color: #cacedb;
    }
  }
}
</style>
